'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('shared/styled/components');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {};

exports.default = function (props) {
  var customStyles = Object.assign({}, defaultStyles, props.style);
  return _react2.default.createElement(_components.ThemedSvg, {
    className: props.className ? props.className + ' icon icon-wallet' : 'icon icon-wallet',
    style: customStyles,
    id: 'Layer_1',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 19 16'
  }, _react2.default.createElement('path', {
    d: 'M18.2,6h-4.4C13.3,6,13,6.4,13,6.8v2.4c0,0.4,0.3,0.8,0.8,0.8h4.4c0.4,0,0.8-0.4,0.8-0.8V6.8 C19,6.4,18.7,6,18.2,6z M15.2,8.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9C16.1,8.5,15.7,8.9,15.2,8.9 z'
  }), _react2.default.createElement('path', {
    d: 'M10.3,10.7l0-5.5c0-0.5,0.4-1,0.9-1H17V1.3C17,0.6,16.4,0,15.8,0H1.2C0.6,0,0,0.6,0,1.3v13.4 C0,15.4,0.6,16,1.2,16h14.5c0.7,0,1.2-0.6,1.2-1.3v-3h-5.8C10.7,11.7,10.3,11.3,10.3,10.7z'
  }));
};